import { BillerGroup } from "model";

/**
 * @class BillerGroupEditItem
 * @classdesc The class definition for the BillerGroupEditItem class.
 * 
 * @param {BillerGroup} billerGroup - The billerGroup that will be edited.
 * 
 * @property {BillerGroup} _billerGroup - The original billerGroup that will be edited.
 * @property {BillerGroup} _editedBillerGroup - The edited billerGroup,
 * which initially has the same values from the "billerGroup" property.
 */
export default class BillerGroupEditItem {
    _billerGroup;
    _editedBillerGroup;
    
    constructor(billerGroup) {
        this.billerGroup = billerGroup;
        this.editedBillerGroup = BillerGroup.init({ ...billerGroup.record });
        this.editedBillerGroup.billers = billerGroup.billers;
    }

    /**
     * @function billerGroup
     * @instance
     * @param {VOID} - Nothing is returned,
     * @description Setter for the billerGroup property
     * @memberof BillerGroupEditItem
     */
    set billerGroup(value) {        
        this._billerGroup = value;
    }

    /**
     * @function editedBillerGroup
     * @instance
     * @param {VOID} - Nothing is returned,
     * @description Setter for the editedBillerGroup property.
     * @memberof BillerGroupEditItem
     */
    set editedBillerGroup(value) {        
        this._editedBillerGroup = value;
    }

    /**
     * @function billerGroup
     * @instance
     * @returns {BillerGroup}
     * @description Getter for the bill property.
     * @memberof BillerGroupEditItem
     */
    get billerGroup() { return this._billerGroup; }

    /**
     * @function editedBillerGroup
     * @instance
     * @returns {BillerGroup}
     * @description Getter for the editedBillerGroup property.
     * @memberof BillerGroupEditItem
     */
    get editedBillerGroup() { return this._editedBillerGroup; }
}